import { Component, Input, OnInit } from '@angular/core';
import { OfferNumberContext } from '../../services/offer-number.service';
import { WizardService } from '../../../core/services/wizard.service';
import {isYANOSIK, loadScript} from '../../../core/utils/utils';

declare const eruda: any;

@Component({
  selector: 'app-step-info',
  templateUrl: './step-info.component.html'
})
export class StepInfoComponent implements OnInit {

  @Input() showStepCounter: boolean;

  readonly offerNumberContext = OfferNumberContext.HEADER;

  private stepCounterClickCount = 0;
  private consoleInitialized: boolean = false;

  get currentStepNumber(): number {
    return this.wizardService.currentStep.isOcDetailsStep ? this.wizardService.currentStepIndex + 1 : null;
  }

  get allStepsNumber(): number {
    return this.wizardService.stepsConfig.filter(step => step.isOcDetailsStep).length;
  }

  constructor(private wizardService: WizardService) { }

  ngOnInit() {
  }

  onStepCounterClick(): void {
    if (isYANOSIK() && !this.consoleInitialized) {
      this.stepCounterClickCount++;
      if (this.stepCounterClickCount >= 5) {
        loadScript('https://cdn.jsdelivr.net/npm/eruda')
            .then(() => eruda.init());
        this.consoleInitialized = true;
      }
    }
  }

}
